module.exports = __webpack_public_path__ + "static/media/quiz9.0268cef4.png";